<div *ngIf="!isShowCommonBtn" class="common-back-btn-blue" [ngClass]="{'showCloseBtn':!isShowCommonBtn}" (click)="closeLearningCampReport()"></div>
<div class="learning-camp-report-wrap" [ngClass]="{'open':!isClosePage,'close':isClosePage}">
  <div class="learning-camp-report-container">
    <p class="camp-name">{{campName}}</p>
    <p class="report-title">结营仪式</p>
    <img class="graduate_banner" src="{{assetsRoute}}/picture/camp/graduate_banner.png" alt="" />
    <p class="graduate_content">
      恭喜你经过不懈的努力，<br />
      完成<b style="color: #2e2e2e">「{{campName}}」</b>的全部课程，<br />
      给坚持到底的你鼓掌！
    </p>
  </div>
  <div class="learning-camp-report-container">
    <div class="learning-camp-title">旅程回顾</div>
    <div class="learning-camp-summary">
      你<span class="striking">{{report.finishedCnt/report.totalCnt*100}}%</span>
      完成<span class="striking">{{report.totalCnt}}</span>门能力的学习，<br />
      能力考核平均等级达到：<span class="striking">{{reportLevelExplain(report.learningPathLvl.avgLvl)}}</span>
    </div>

    <div class="learning-camp-detail">
      <ul class="learning-camp-detail-item clearfix">
        <li><b>能力名称</b></li>
        <li class="textLeft"><b>能力考核等级</b></li>
      </ul>
      <ul class="learning-camp-detail-item clearfix" *ngFor="let item of report.learningPathLvl.details;let i = index">
        <li>{{item.name}}</li>
        <li>
          <span *ngIf="item.lvl">{{reportLevelExplain(item.lvl)}}</span>
          <span *ngIf="!item.lvl">没有能力考核</span>
          <span *ngIf="item.lvl>3"><img src="{{assetsRoute}}/picture/camp/nice.png" /></span>
        </li>
      </ul>
    </div>

    <div class="learning-camp-certificate" *ngIf="report.achievementLvl == 0">
      <p class="fail-title">很遗憾！你未能在训练营周期内完成所有能力课程的学习，无法取得毕业证。</p>
    </div>
    <div class="learning-camp-certificate" *ngIf="report.achievementLvl != 0">
      <p class="certificate-title">
        <span class="striking">恭喜你</span><br />
        顺利完成学习，获得<span><b>「{{reportAchievementExplain(report.achievementLvl)}}」</b></span>
      </p>

      <div class="user-certificate-final">
        <img id="user-certificate-img" src="" alt="" />
      </div>

      <div class="user-certificate" id="user-certificate">
        <img src="../../../assets/picture/camp/graduate_{{report.achievementLvl}}.png" alt="" />
        <p><b>{{userName}}</b></p>
      </div>
      <div class="certificate-explain">
        <ul class="clearfix" style="height: .8rem">
          <li><b>结业证书</b></li>
          <li><p>在周期内100%完成所有能力的学习</p></li>
        </ul>
        <ul class="clearfix">
          <li><b>毕业证书</b></li>
          <li><p>在周期内100%完成所有能力的学习</p><p>能力考核的平均等级为一般或良好</p></li>
        </ul>
        <ul class="clearfix">
          <li><b>优秀毕业证书</b></li>
          <li><p>在周期内100%完成所有能力的学习</p><p>能力考核的平均等级为优秀及以上</p></li>
        </ul>
      </div>
    </div>

  </div>

  <div class="learning-camp-report-container">
    <div class="learning-camp-title">寄语</div>
    <p class="graduate_content" style="margin-top: .5rem">
      知识的学习告一段落，<br />
      技能的应用才刚刚开始！<br />
      <b style="color: #2e2e2e">「{{campName}}」</b>课程将会<b style="color: #2e2e2e">持续开放一年，</b><br />
      在这一年中你可以随时回来温故知新， <br />
      英跃always by your side！ <br />
      期望你能够在实际工作中应用所学， <br />
      华丽蜕变！
    </p>
  </div>

  <div class="learning-camp-report-container" *ngIf="isShowCommonBtn">
    <div class="report-bottom-btn" (click)="closeLearningCampReport()">
      返回首页
    </div>
  </div>


  <div style="height:.5rem"></div>
</div>



// WEBPACK FOOTER //
// ./src/app/learning-camp/camp-report/learning-camp-report.component.html